import { useGetLapsedAds } from '@/features/billing/api/get-lapsed-ads';

const formatDay = (iso: string) =>
  new Date(iso).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    timeZone: 'Europe/London',
  });

/**
 * Under the "subscription has ended" banner: the Borradh-launched campaigns
 * still spending the clinic's money, each linked to Meta Ads Manager. Not to
 * our own advertising page: with the subscription ended the app shows this
 * banner and refuses everything else, so that link would lead nowhere.
 */
export function LapsedAdsNotice({ enabled }: { enabled: boolean }) {
  const { notice } = useGetLapsedAds({ enabled });
  if (!notice || notice.campaigns.length === 0) return null;

  return (
    <p
      className="mx-auto max-w-3xl pb-1.5 text-center text-[12px] leading-[17px] text-white/90"
      data-lapsed-ads-notice=""
    >
      These campaigns are still running and spending your ad budget:{' '}
      {notice.campaigns.map((c, i) => (
        <span key={c.metaCampaignId}>
          {i > 0 ? ', ' : null}
          <a
            href={c.pauseUrl}
            target="_blank"
            rel="noreferrer"
            className="font-medium underline underline-offset-2 hover:text-white"
          >
            {c.name}
          </a>
        </span>
      ))}
      . Pause them in Meta Ads Manager
      {notice.pauseOn
        ? `, or we will pause them on ${formatDay(notice.pauseOn)}.`
        : ', or tell us if you want to keep them running.'}
    </p>
  );
}
